/*
 * Función para depurar posiciones de publicidad
 */
function debugVam($elm) {
  const Logger = nibara.logger;
  $elm.each(function(i,v) {
    try {
      let $v = Voonto.$(v);
      if ($v.data('debugVam')) {
        return;
      }

      $v.data('debugVam', 1);
      let media = window.vocento.config.vam.media;
      let posiciones;
      if (Voonto.is.mobile())
        posiciones = media.posicion_mobile;
      else {
        posiciones = media.posicion_desktop;
      }

      let position = v.getAttribute('data-voc-vam-position');
      $v.html(position);
      if (!$v.attr('id')) {
        $v.attr('id', position+'-id');
      }
      let posicion = posiciones[position];
      //Logger.debug(`[vam-debug] position: ${position}`, posicion);
      if (position && posicion && posicion.dimensiones) {
        let dims = JSON.parse(posicion.dimensiones);
        let minDim = null;
        let maxWidth = $(window).width();
        let minHeight = 2000;
        for(let i=dims.length-1; i>=0; i--) {
          if (maxWidth > dims[i][0] && minHeight > dims[i][1]) {
            minDim = dims[i];
            minHeight = dims[i][1];
          }
        }
        if (minDim) {
          //Logger.debug(`[vam-debug] position: ${position} - ${width}x${height}`, posicion);
          $v.css({
            "width": minDim[0]+"px", "height": minDim[1]+"px",
            "background-color": "cyan", "text-align": "center",
            "padding-top": "25px", "display": "block",
          });
        }
      }
    } catch (ex) {
      Logger.error('[vam-debug] exception:', v, ex);
    }
  });
  setTimeout(function(){
      $elm.trigger('vam:slotrendered');
  }, 3000);
}

function initVamDebug(app) 
{
  const Logger = nibara.logger;
  debugVam(Voonto.$('[data-voc-vam]'));
  app.on('voonto:reload', function(ev, elm) {
    try{
      debugVam(Voonto.$(elm).find('[data-voc-vam]'));
    } catch (ex) {
      Logger.error('[vam-debug] exception:', ex);
    }
  });
}

export default initVamDebug;


// WEBPACK FOOTER //
// ./src/scripts/layout/vam-debug.js